import { render, staticRenderFns } from "./CreateFactorySteps.vue?vue&type=template&id=06e1f5c6&scoped=true"
import script from "./CreateFactorySteps.vue?vue&type=script&lang=ts"
export * from "./CreateFactorySteps.vue?vue&type=script&lang=ts"
import style0 from "./CreateFactorySteps.vue?vue&type=style&index=0&id=06e1f5c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e1f5c6",
  null
  
)

export default component.exports